module.exports = __webpack_public_path__ + "media/about_us/Alessandro-2bb961a1.png";